export default "__VITE_ASSET__DGWXNOTo__"